import { useEffect, useState } from 'react';

function fullscreenParent(): HTMLElement | null {
    const browserDocument = document as Document & {
        webkitFullscreenElement?: Element | null;
        msFullscreenElement?: Element | null;
    };
    return (document.fullscreenElement ?? browserDocument.webkitFullscreenElement
        ?? browserDocument.msFullscreenElement ?? null) as HTMLElement | null;
}

/** Dialog portals must stay inside the browser's fullscreen element. */
export function useFullscreenDialogParent(parent?: HTMLElement | null) {
    const [fullscreen, setFullscreen] = useState(fullscreenParent);
    useEffect(() => {
        const update = () => setFullscreen(fullscreenParent());
        const events = ['fullscreenchange', 'webkitfullscreenchange', 'MSFullscreenChange'];
        events.forEach(event => document.addEventListener(event, update));
        update();
        return () => events.forEach(event => document.removeEventListener(event, update));
    }, []);
    if (fullscreen) return parent && fullscreen.contains(parent) ? parent : fullscreen;
    return parent ?? undefined;
}
